/* global axios */
import ApiClient from './ApiClient';

class ContactFavoriteImoveisAPI extends ApiClient {
  constructor() {
    super('contacts', { accountScoped: true });
  }

  basePath(contactId) {
    return `${this.url}/${contactId}/contact_favorite_imoveis`;
  }

  get(contactId, params = {}) {
    const query = new URLSearchParams(
      Object.entries(params).filter(
        ([, value]) => value !== '' && value != null
      )
    ).toString();

    return axios.get(
      query ? `${this.basePath(contactId)}?${query}` : this.basePath(contactId)
    );
  }

  create(contactId, payload) {
    return axios.post(this.basePath(contactId), payload);
  }

  update(contactId, id, payload) {
    return axios.patch(`${this.basePath(contactId)}/${id}`, payload);
  }

  delete(contactId, id) {
    return axios.delete(`${this.basePath(contactId)}/${id}`);
  }

  bulkCreate(contactId, payload) {
    return axios.post(`${this.basePath(contactId)}/bulk_create`, payload);
  }

  bulkDestroy(contactId, payload) {
    return axios.delete(`${this.basePath(contactId)}/bulk_destroy`, {
      data: payload,
    });
  }

  moveItems(contactId, payload) {
    return axios.post(`${this.basePath(contactId)}/move_items`, payload);
  }
}

export default new ContactFavoriteImoveisAPI();
